import { vars } from '@repo/config';
import { createPostFetchOptions } from './helper';

interface IRestoreUserResponse {
  success: boolean;
  email?: string;
  error?: string;
}

export async function restoreUser(
  cookieHeader: string,
  userId: string,
): Promise<IRestoreUserResponse> {
  const restoreUrl = new URL('/restore-user', vars.url.identityUrl);
  const response = await fetch(
    restoreUrl.toString(),
    createPostFetchOptions({
      cookieHeader,
      body: { userId },
    }),
  );

  if (!response.ok) {
    const errorData = (await response.json()) as { error?: string };
    return { success: false, error: errorData.error || 'Failed to restore user' };
  }

  const data = (await response.json()) as { restored: boolean; email: string };
  return { success: true, email: data.email };
}
